import "../auth.scss";
import React, { useState } from "react";
import { LogoImg2 } from "assets/images";
import { useNavigate, useParams } from "react-router-dom";
import { Input } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { resetPasswordApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import usePasswordToggle from "common/UsePasswordToggle";
import {ValidateInput} from "validation";
import { auth } from "validation/schema/auth";
import commonMessages from "constants/commonMessage";

const ResetPassword = ({ setSteps }) => {
  const [inputData, setInputData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [newPasswordToggle, newPasswordIcon] = usePasswordToggle();
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Reset");
  const { token } = useParams();

  const nevigateRoute = useNavigate();

  // Input change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "resetPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // Reset Password Handler

  const resetPasswordHandler = async () => {
    if (validation()) {
      try {
        if (inputData.newPassword !== inputData.confirmPassword) {
          toastMessage(
            commonMessages.NEWPASSWORD_CONFIRMPASSWORD_SAME,
            "warning",
            "reset_password"
          );
          return;
        }
        setButtonLoader(true);
        const reqData = {
          ...inputData,
          token,
        };
        const { data: responseData, status } = await resetPasswordApi(reqData);
        if (status === 200) {
          toastMessage(responseData?.message, "success", "reset_password");
          nevigateRoute("/");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_section">
        <div className="header">
          <div className="container">
            <img src={LogoImg2} alt="" />
          </div>
        </div>
        <div className="container">
          <div className="auth_content">
            <div className="content_right">
              <form>
                <div className="form_title">
                  <h2>Reset Pasword</h2>
                  <p>
                    Please enter a new password below to reset your account
                    password. Make sure to choose a strong password that
                    includes a combination of letters, numbers, and special
                    characters to keep your account secure.
                  </p>
                </div>
                <div className="content">
                  <div className="form_field has_icon">
                    <Input
                      className={"form-control input"}
                      type={newPasswordToggle}
                      label="New Password"
                      placeholder="Enter New Password"
                      name="newPassword"
                      maxLength={25}
                      value={inputData?.newPassword}
                      onChange={onChangeHandler}
                      error={error?.newPassword}
                      extraError={error?.newPasswordErr}
                    />
                    <span className="password_icons">{newPasswordIcon}</span>
                  </div>
                  <div className="form_field has_icon">
                    <Input
                      className={"form-control input"}
                      type={"text"}
                      label="Confirm Password"
                      placeholder="Enter Confirm Password"
                      name="confirmPassword"
                      maxLength={25}
                      value={inputData?.confirmPassword}
                      onChange={onChangeHandler}
                      error={error?.confirmPassword}
                      extraError={error?.confirmPasswordErr}
                    />
                  </div>
                  <div className="button_wrap">
                    <button
                      type="button"
                      ref={buttonLoader}
                      className="button"
                      onClick={resetPasswordHandler}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
